import { createStyles } from '@mantine/core';
import { memo } from 'react';
import type { IRichEditorProps } from '../../../components/RichEditor';
import { RichEditor } from '../../../components/RichEditor';

const useStyles = createStyles(() => ({
	content: {
		'.ProseMirror': {
			minHeight: `calc(5 * 1.5rem)`, // 1.5rem is the line height of the editor
		},

		'.heading-actions, .block-menu-trigger': {
			display: 'none !important',
		},
		'.heading-content::before': {
			display: 'none !important',
		},
		'h1::before, h2::before, h3::before, h4::before, h5::before, h6::before': {
			display: 'none !important',
		},
	},
}));

export const ContentInput = memo((props: Partial<IRichEditorProps>) => {
	const { classes } = useStyles();

	return (
		<RichEditor
			className={classes.content}
			readOnly={false}
			disableTopGap
			{...props}
		/>
	);
});
